const LockIcon: React.FC<React.SVGAttributes<NonNullable<unknown>>> = (
  props,
) => {
  return (
    <svg viewBox="0 0 15 15" fill="none" {...props}>
      <path
        d="M1 10.1c0-1.838 0-2.758.571-3.329C2.142 6.2 3.061 6.2 4.9 6.2h5.2c1.838 0 2.758 0 3.329.571.571.57.571 1.49.571 3.329 0 1.838 0 2.758-.571 3.328-.571.572-1.49.572-3.329.572H4.9c-1.838 0-2.758 0-3.329-.572C1 12.858 1 11.938 1 10.1z"
        fill="#E7DEFF"
        stroke="#8065C9"
      />
      <path
        d="M3.602 6.2V4.9a3.9 3.9 0 017.8 0v1.3"
        stroke="#8065C9"
        strokeLinecap="round"
      />
      <path
        d="M4.898 10.1h.006-.006zm2.595 0h.005-.005zm2.6 0h.005-.005z"
        fill="#2D224C"
      />
      <path
        d="M4.898 10.1h.006m2.589 0h.005m2.595 0h.005"
        stroke="#8065C9"
        strokeWidth={1.2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default LockIcon;
